import Box from '@mui/material/Box';

import { UploadTabPanelProps } from 'src/interfaces/FileManager';

const UploadTabPanel = ({ children, value, index, ...other }: UploadTabPanelProps) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`upload-tabpanel-${index}`}
    aria-labelledby={`upload-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

export default UploadTabPanel;
